<template>
	<div class="newsDetail">
		<div class="widthBox">
			<div class="newsTitle">
				<h2>{{newsData.title}}</h2>
			</div>
			<div class="newsCont" v-html="newsData.content">
				
			</div>
		</div>
	</div>
</template>

<script>
	export default {
	  name: 'news_detail',
	  components: {
	  },
	  data: function() {
	  	return {
	  		newsData:{},
	  	};
	  },
	  created() {
	  	this.$api.get('home/index/rawmaterialsdetail',{
			id:this.$route.query.id
	  	}).then(res=>{
	  		this.newsData = res.data
	  	})
	  },
	  mounted() {
	  	this.$nextTick(function(){
	  		if(this.$route.query.to != undefined || this.$route.query.to != null){
	  			setTimeout(()=>{
	  				document.getElementById(this.$route.query.to).scrollIntoView()
	  			},500)
	  		}else{
	  			document.body.scrollIntoView()
	  		}
	  	})
	  },
	}
</script>

<style lang="scss" scoped="scoped">
	.newsDetail{
		width:100%;
		margin:0 auto;
		.newsTitle{
			padding:80px 0 40px;
			border-bottom:1px solid #777;
			h2{
				font-size:32px;
				text-align: center;
				color: #777;
			}
		}
		.newsCont{
			padding:40px 0;
		}
		
	}
	@media screen and(max-width:768px) {
		.newsDetail{
			.newsTitle{
				padding:20px 0 10px;
				border-bottom:none;
				h2{
					font-size:18px;
					text-align: left;
				}
				p{
					text-align: left;
					font-size:14px;
					margin-top:10px;
				}
			}
			.newsCont{
				padding:20px 0;
			}
			
		}
	}
</style>
